module.exports = __webpack_public_path__ + "static/img/cpzs_banner.5d5f927.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/cpzs_banner.png
// module id = RVhw
// module chunks = 0